import React, { useState } from 'react';
import { MapContainer, TileLayer, GeoJSON, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import countriesData from '../../data/countries.json';

const WorldMap = ({ onSelectCountry }) => {
    const [map, setMap] = useState(null);

    const countryStyle = (feature) => ({
        fillColor: feature.properties.status === 'visited' ? 'blue' : 'red',
        weight: 2,
        opacity: 1,
        color: 'white',
        dashArray: '3',
        fillOpacity: 0.7
    });

    const onEachCountry = (country, layer) => {
        layer.on({
            click: () => {
                onSelectCountry(country);
            }
        });
    };

    const renderMarkers = () => {
        return countriesData.map((country) =>
            country.cities.map((city) => {
                const iconUrl = `/pins/${city.color}.png`; // Path to the colored pin icon
                const customIcon = L.icon({
                    iconUrl,
                    iconSize: [15, 25],   // Size of the icon
                    iconAnchor: [12, 41], // Point of the icon which will correspond to marker's location
                    popupAnchor: [1, -34], // Point from which the popup should open relative to the iconAnchor
                });

                return (
                    <Marker
                        key={city.name}
                        position={city.coordinates}
                        icon={customIcon}
                    >
                        <Popup>{city.name}</Popup>
                    </Marker>
                );
            })
        );
    };


    return (
        <MapContainer
            center={[25.505, -0.09]}
            zoom={2}
            whenCreated={setMap}
            style={{ height: '80vh', width: '100%' }}
        >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <GeoJSON
                data={countriesData}
                style={countryStyle}
                onEachFeature={onEachCountry}
            />
            {renderMarkers()}
        </MapContainer>
    );
};

export default WorldMap;
